import React, { FC } from 'react';

import { LengthRange } from '../../../types/lengthRange';

import styles from './index.module.scss';

interface StatusBarItemRangeStatusProps {
	range: LengthRange | undefined;
	clampTo?: LengthRange;
}

export const StatusBarItemRangeStatus: FC<StatusBarItemRangeStatusProps> = ({ range, clampTo }) => {
	const clampedRange =
		range && clampTo
			? {
					depthFrom: Math.max(clampTo.depthFrom, range.depthFrom),
					depthTo: Math.min(clampTo.depthTo, range.depthTo),
				}
			: undefined;
	return (
		<div className={styles.item} data-statusbar-item-type="visible-range">
			{clampedRange ? (
				<>
					<span className={styles.length}>{clampedRange.depthFrom.toFixed(2)}</span>m &nbsp;-&nbsp;
					<span className={styles.length}>{clampedRange.depthTo.toFixed(2)}</span>m
				</>
			) : (
				'-'
			)}
		</div>
	);
};
